import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/img/add-image.svg'
import _imports_1 from '@/assets/img/icon/deleteFilledAntDesignRed.svg'


const _hoisted_1 = { id: "agent-form" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h5", null, "Tambah Kurir", -1)
const _hoisted_3 = { class: "p-grid" }
const _hoisted_4 = { class: "border-solid border-2 p-4 mt-6 rounded-lg" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h6", null, "Informasi Akun ( untuk login )", -1)
const _hoisted_6 = { class: "mt-6 grid grid-cols-1 sm:grid-cols-2 gap-8 mb-6" }
const _hoisted_7 = { class: "mb-4 md:pl-6 pl-0" }
const _hoisted_8 = { class: "p-inputgroup rounded-inputgroup" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createVNode("i", { class: "pi pi-phone" })
], -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "p-error" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "p-error" }
const _hoisted_15 = { class: "mb-4 md:pl-6 pl-0" }
const _hoisted_16 = { class: "p-inputgroup rounded-inputgroup relative" }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createVNode("i", { class: "pi pi-lock" })
], -1)
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "p-error" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "p-error" }
const _hoisted_23 = {
  class: "border-solid border-2 p-4 mt-6  ",
  style: {"border-radius":"0.5rem"}
}
const _hoisted_24 = /*#__PURE__*/_createVNode("h6", null, "Informasi Kurir", -1)
const _hoisted_25 = { class: "mt-6 grid grid-cols-1 sm:grid-cols-2 gap-8" }
const _hoisted_26 = { class: "md:pl-6 pl-0" }
const _hoisted_27 = { class: "p-field mb-4" }
const _hoisted_28 = /*#__PURE__*/_createVNode("label", {
  for: "courierEmail",
  class: "text-body2"
}, "Email", -1)
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "p-error" }
const _hoisted_31 = {
  key: 1,
  class: "p-error"
}
const _hoisted_32 = { class: "p-field mb-4" }
const _hoisted_33 = /*#__PURE__*/_createVNode("label", {
  for: "courierName",
  class: "text-body2"
}, "Nama Lengkap", -1)
const _hoisted_34 = {
  key: 0,
  class: "p-error"
}
const _hoisted_35 = { class: "p-field mb-4" }
const _hoisted_36 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "text-body2"
}, "Tempat, Tanggal Lahir", -1)
const _hoisted_37 = { class: " grid grid-cols-2 gap-4 mt-1" }
const _hoisted_38 = { class: "" }
const _hoisted_39 = {
  key: 0,
  class: "p-error"
}
const _hoisted_40 = { class: "w-full" }
const _hoisted_41 = { class: "p-inputgroup rounded-inputgroup" }
const _hoisted_42 = /*#__PURE__*/_createVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createVNode("i", { class: "pi pi-calendar" })
], -1)
const _hoisted_43 = {
  key: 0,
  class: "p-error"
}
const _hoisted_44 = { class: "p-field mb-4" }
const _hoisted_45 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "text-body2"
}, "Jenis Kelamin", -1)
const _hoisted_46 = { class: "flex gap-6 mt-1" }
const _hoisted_47 = { class: "p-field mb-4" }
const _hoisted_48 = /*#__PURE__*/_createVNode("label", {
  for: "address",
  class: "text-body2"
}, "Alamat Lengkap", -1)
const _hoisted_49 = {
  key: 0,
  class: "p-error"
}
const _hoisted_50 = { class: "p-field mb-4" }
const _hoisted_51 = /*#__PURE__*/_createVNode("label", {
  for: "educationLevel",
  class: "text-body2"
}, "Jenjang Pendidikan", -1)
const _hoisted_52 = {
  key: 0,
  class: "p-error"
}
const _hoisted_53 = { class: "p-field mb-4" }
const _hoisted_54 = /*#__PURE__*/_createVNode("label", {
  for: "mariedStatus",
  class: "text-body2"
}, "Status Pernikahan", -1)
const _hoisted_55 = {
  key: 0,
  class: "p-error"
}
const _hoisted_56 = { class: "md:pl-6 pl-0" }
const _hoisted_57 = { class: "p-field mb-4" }
const _hoisted_58 = /*#__PURE__*/_createVNode("label", {
  class: "text-body2",
  id: "ktp"
}, "No. KTP / SIM", -1)
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { class: "p-error" }
const _hoisted_61 = {
  key: 1,
  class: "p-error"
}
const _hoisted_62 = { class: "mt-2 flex justify-start" }
const _hoisted_63 = {
  key: 0,
  class: "relative pr-3 pt-1"
}
const _hoisted_64 = /*#__PURE__*/_createVNode("i", { class: "pi pi-times text-white w-4 h-4" }, null, -1)
const _hoisted_65 = {
  key: 1,
  class: "relative pr-3 pt-1"
}
const _hoisted_66 = /*#__PURE__*/_createVNode("i", { class: "pi pi-times text-white w-4 h-4" }, null, -1)
const _hoisted_67 = { class: "p-field mb-4" }
const _hoisted_68 = /*#__PURE__*/_createVNode("label", {
  for: "transportationType",
  class: "text-body2"
}, "Jenis Kendaraan", -1)
const _hoisted_69 = {
  key: 0,
  class: "p-error"
}
const _hoisted_70 = { class: "mt-2 flex justify-start" }
const _hoisted_71 = {
  key: 0,
  class: "relative pr-3 pt-1"
}
const _hoisted_72 = /*#__PURE__*/_createVNode("i", { class: "pi pi-times text-white w-4 h-4" }, null, -1)
const _hoisted_73 = {
  key: 1,
  class: "relative pr-3 pt-1"
}
const _hoisted_74 = /*#__PURE__*/_createVNode("i", { class: "pi pi-times text-white w-4 h-4" }, null, -1)
const _hoisted_75 = { class: "p-field mb-4" }
const _hoisted_76 = /*#__PURE__*/_createVNode("label", {
  for: "statusVaksin",
  class: "text-body2"
}, "Covid-19 Vaksin", -1)
const _hoisted_77 = {
  key: 0,
  class: "p-error"
}
const _hoisted_78 = { class: "mt-2 flex justify-start" }
const _hoisted_79 = {
  key: 0,
  class: "relative pr-3 pt-1"
}
const _hoisted_80 = /*#__PURE__*/_createVNode("i", { class: "pi pi-times text-white w-4 h-4" }, null, -1)
const _hoisted_81 = {
  key: 1,
  class: "relative pr-3 pt-1"
}
const _hoisted_82 = /*#__PURE__*/_createVNode("i", { class: "pi pi-times text-white w-4 h-4" }, null, -1)
const _hoisted_83 = { class: "flex flex-col p-6" }
const _hoisted_84 = /*#__PURE__*/_createVNode("h6", null, "Aktif", -1)
const _hoisted_85 = { class: "flex action-button px-5 py-5 gap-3" }
const _hoisted_86 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_87 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-3 h-3",
  alt: "delete"
}, null, -1)
const _hoisted_88 = /*#__PURE__*/_createVNode("i", { class: "pi pi-lock text-white" }, null, -1)
const _hoisted_89 = /*#__PURE__*/_createVNode("i", { class: "pi pi-unlock text-white" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Password = _resolveComponent("Password")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_file_upload = _resolveComponent("file-upload")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")
  const _component_GoogleAutocomplete = _resolveComponent("GoogleAutocomplete")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_Card, { class: "user-edit w-full" }, {
      content: _withCtx(() => [
        _hoisted_2,
        _createVNode("form", {
          onSubmit: _cache[25] || (_cache[25] = _withModifiers(($event: any) => (_ctx.submitData(!_ctx.v$.$invalid)), ["prevent"]))
        }, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_component_InputText, {
                      id: "phone",
                      modelValue: _ctx.v$.phone.$model,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.phone.$model = $event)),
                      placeholder: "Pastikan Nomor Telephone Aktif",
                      class: "input-primary rounded-r-lg",
                      type: "tel",
                      disabled: _ctx.isDisabled
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  ((_ctx.v$.phone.$invalid && _ctx.submitted) || _ctx.v$.phone.$pending.$response)
                    ? (_openBlock(), _createBlock("div", _hoisted_10, [
                        (_ctx.v$.phone.required.$invalid)
                          ? (_openBlock(), _createBlock("div", _hoisted_11, [
                              _createVNode("p", _hoisted_12, [
                                _createVNode("small", null, _toDisplayString(_ctx.v$.phone.required.$message), 1)
                              ])
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_13, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.v$.phone.$errors, (error, index) => {
                                return (_openBlock(), _createBlock("span", {
                                  id: "new-password-error",
                                  key: index
                                }, [
                                  _createVNode("p", _hoisted_14, [
                                    _createVNode("small", null, _toDisplayString(error.$message), 1)
                                  ])
                                ]))
                              }), 128))
                            ]))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_15, [
                  _createVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createVNode(_component_Password, {
                      id: "password",
                      placeholder: "Password",
                      modelValue: _ctx.v$.password.$model,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.password.$model = $event)),
                      feedback: false,
                      toggleMask: !_ctx.isDisabled,
                      class: "",
                      disabled: _ctx.isDisabled
                    }, null, 8, ["modelValue", "toggleMask", "disabled"])
                  ]),
                  ((_ctx.v$.password.$invalid && _ctx.submitted) || _ctx.v$.password.$pending.$response)
                    ? (_openBlock(), _createBlock("div", _hoisted_18, [
                        (_ctx.v$.password.required.$invalid)
                          ? (_openBlock(), _createBlock("div", _hoisted_19, [
                              _createVNode("p", _hoisted_20, [
                                _createVNode("small", null, _toDisplayString(_ctx.v$.password.required.$message), 1)
                              ])
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_21, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.v$.password.$errors, (error, index) => {
                                return (_openBlock(), _createBlock("span", {
                                  id: "new-password-error",
                                  key: index
                                }, [
                                  _createVNode("p", _hoisted_22, [
                                    _createVNode("small", null, _toDisplayString(error.$message), 1)
                                  ])
                                ]))
                              }), 128))
                            ]))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_23, [
              _hoisted_24,
              _createVNode("div", _hoisted_25, [
                _createVNode("div", _hoisted_26, [
                  _createVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createVNode(_component_InputText, {
                      id: "courierEmail",
                      class: "p-inputtext p-component input-primary w-full mt-1 rounded-lg",
                      name: "courierEmail",
                      modelValue: _ctx.v$.courierEmail.$model,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.courierEmail.$model = $event)),
                      type: "text",
                      placeholder: "Pastikan Email Aktif"
                    }, null, 8, ["modelValue"]),
                    (_ctx.v$.courierEmail.$error && _ctx.submitted)
                      ? (_openBlock(), _createBlock("span", _hoisted_29, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.v$.courierEmail.$errors, (error, index) => {
                            return (_openBlock(), _createBlock("span", {
                              id: "new-courierEmail-error",
                              key: index
                            }, [
                              _createVNode("small", _hoisted_30, _toDisplayString(error.$message), 1)
                            ]))
                          }), 128))
                        ]))
                      : (
                      (_ctx.v$.courierEmail.$invalid && _ctx.submitted) || _ctx.v$.courierEmail.$pending.$response
                    )
                        ? (_openBlock(), _createBlock("small", _hoisted_31, _toDisplayString(_ctx.v$.courierEmail.required.$message), 1))
                        : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createVNode(_component_InputText, {
                      maxlength: "50",
                      id: "courierName",
                      class: "p-inputtext p-component input-primary w-full mt-1 rounded-lg",
                      name: "courierName",
                      modelValue: _ctx.v$.courierName.$model,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.courierName.$model = $event)),
                      type: "text"
                    }, null, 8, ["modelValue"]),
                    (
                        (_ctx.v$.courierName.$invalid && _ctx.submitted) || _ctx.v$.courierName.$pending.$response
                      )
                      ? (_openBlock(), _createBlock("small", _hoisted_34, _toDisplayString(_ctx.v$.courierName.required.$message), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_35, [
                    _hoisted_36,
                    _createVNode("div", _hoisted_37, [
                      _createVNode("div", _hoisted_38, [
                        _createVNode(_component_InputText, {
                          maxlength: "50",
                          placeholder: "Tempat Lahir",
                          id: "placeBirth",
                          class: "p-inputtext p-component input-primary w-full rounded-lg",
                          name: "Tempat Lahir",
                          modelValue: _ctx.v$.placeBirth.$model,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.placeBirth.$model = $event)),
                          type: "text"
                        }, null, 8, ["modelValue"]),
                        (
                            (_ctx.v$.placeBirth.$invalid && _ctx.submitted) ||
                              _ctx.v$.placeBirth.$pending.$response
                          )
                          ? (_openBlock(), _createBlock("small", _hoisted_39, _toDisplayString(_ctx.v$.placeBirth.required.$message), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode("div", _hoisted_40, [
                        _createVNode("div", _hoisted_41, [
                          _createVNode(_component_Calendar, {
                            id: "birthDate",
                            dateFormat: "dd-mm-yy",
                            placeholder: "DD-MM-YYYY",
                            class: " input-primary rounded-l-lg",
                            modelValue: _ctx.v$.birthDate.$model,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.birthDate.$model = $event))
                          }, null, 8, ["modelValue"]),
                          _hoisted_42
                        ]),
                        (
                            (_ctx.v$.birthDate.$invalid && _ctx.submitted) || _ctx.v$.birthDate.$pending.$response
                          )
                          ? (_openBlock(), _createBlock("small", _hoisted_43, _toDisplayString(_ctx.v$.birthDate.required.$message), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_44, [
                    _hoisted_45,
                    _createVNode("div", _hoisted_46, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.genderOption, (data) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "flex items-center mb-2 cursor-pointer",
                          key: data.key
                        }, [
                          _createVNode(_component_RadioButton, {
                            id: data.key,
                            class: "mr-2 radio-primary",
                            value: data.value,
                            modelValue: _ctx.gender,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.gender = $event))
                          }, null, 8, ["id", "value", "modelValue"]),
                          _createVNode("label", {
                            for: data.key,
                            class: "text-body2"
                          }, _toDisplayString(data.name), 9, ["for"])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createVNode("div", _hoisted_47, [
                    _hoisted_48,
                    _createVNode(_component_Textarea, {
                      autocomplete: "nope",
                      id: "address",
                      ref: "addressRef",
                      modelValue: _ctx.v$.address.$model,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.v$.address.$model = $event)),
                      class: "p-inputtext p-component input-primary mt-1 w-full rounded-lg",
                      rows: "5",
                      cols: "30"
                    }, null, 8, ["modelValue"]),
                    ((_ctx.v$.address.$invalid && _ctx.submitted) || _ctx.v$.address.$pending.$response)
                      ? (_openBlock(), _createBlock("small", _hoisted_49, _toDisplayString(_ctx.v$.address.required.$message), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_50, [
                    _hoisted_51,
                    _createVNode(_component_Multiselect, {
                      id: "educationLevel",
                      class: "mt-1 input-primary",
                      modelValue: _ctx.v$.lastEducation.$model,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.v$.lastEducation.$model = $event)),
                      placeholder: "Pilih Jenjang Pendidikan",
                      options: _ctx.educationLevelOption,
                      searchable: true
                    }, null, 8, ["modelValue", "options"]),
                    (
                        (_ctx.v$.lastEducation.$invalid && _ctx.submitted) ||
                          _ctx.v$.lastEducation.$pending.$response
                      )
                      ? (_openBlock(), _createBlock("small", _hoisted_52, _toDisplayString(_ctx.v$.lastEducation.required.$message), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_53, [
                    _hoisted_54,
                    _createVNode(_component_Multiselect, {
                      id: "mariedStatus",
                      class: "mt-1 input-primary",
                      modelValue: _ctx.v$.mariedStatus.$model,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.v$.mariedStatus.$model = $event)),
                      placeholder: "Status Pernikahan",
                      options: _ctx.mariedStatusOption,
                      searchable: true
                    }, null, 8, ["modelValue", "options"]),
                    (
                        (_ctx.v$.mariedStatus.$invalid && _ctx.submitted) ||
                          _ctx.v$.mariedStatus.$pending.$response
                      )
                      ? (_openBlock(), _createBlock("small", _hoisted_55, _toDisplayString(_ctx.v$.mariedStatus.required.$message), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_56, [
                  _createVNode("div", _hoisted_57, [
                    _hoisted_58,
                    _createVNode(_component_InputText, {
                      maxlength: "20",
                      id: "ktp",
                      class: "input-primary mt-1 w-full rounded-lg",
                      modelValue: _ctx.v$.ktp.$model,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.v$.ktp.$model = $event)),
                      type: "tel"
                    }, null, 8, ["modelValue"]),
                    (_ctx.v$.ktp.$error && _ctx.submitted)
                      ? (_openBlock(), _createBlock("span", _hoisted_59, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.v$.ktp.$errors, (error, index) => {
                            return (_openBlock(), _createBlock("span", {
                              id: "validasi-ktp-error",
                              key: index
                            }, [
                              _createVNode("small", _hoisted_60, _toDisplayString(error.$message), 1)
                            ]))
                          }), 128))
                        ]))
                      : ((_ctx.v$.ktp.$invalid && _ctx.submitted) || _ctx.v$.ktp.$pending.$response)
                        ? (_openBlock(), _createBlock("small", _hoisted_61, _toDisplayString(_ctx.v$.ktp.required.$message), 1))
                        : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_62, [
                      (_ctx.tempUploadKtp)
                        ? (_openBlock(), _createBlock("div", _hoisted_63, [
                            (_ctx.tempUploadKtp !== null)
                              ? (_openBlock(), _createBlock("div", {
                                  key: 0,
                                  class: "flex items-center rounded-full bg-red-500 absolute p-1 cursor-pointer",
                                  style: {"right":"0","top":"0","z-index":"5"},
                                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.tempUploadKtp = null))
                                }, [
                                  _hoisted_64
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode("img", {
                              src: _ctx.tempUploadKtp,
                              class: "w-full h-20"
                            }, null, 8, ["src"])
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_65, [
                            (_ctx.uploadKtp.src !== null)
                              ? (_openBlock(), _createBlock("div", {
                                  key: 0,
                                  class: "flex items-center rounded-full bg-red-500 absolute p-1 cursor-pointer",
                                  style: {"right":"0","top":"0","z-index":"5"},
                                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.removeImage('uploadKtp')))
                                }, [
                                  _hoisted_66
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_file_upload, {
                              ref: "refUploadKtp",
                              "input-id": "idUploadKtp",
                              onInputFile: _ctx.onUploadKtp,
                              accept: "image/*"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.uploadKtp?.src === null)
                                  ? (_openBlock(), _createBlock("img", {
                                      key: 0,
                                      class: "w-full h-20",
                                      src: _imports_0,
                                      alt: _ctx.uploadKtp?.name
                                    }, null, 8, ["alt"]))
                                  : (_openBlock(), _createBlock("img", {
                                      key: 1,
                                      class: "w-full object-cover rounded-lg h-32",
                                      src: _ctx.uploadKtp.src,
                                      alt: _ctx.uploadKtp.name
                                    }, null, 8, ["src", "alt"]))
                              ]),
                              _: 1
                            }, 8, ["onInputFile"])
                          ]))
                    ])
                  ]),
                  _createVNode("div", _hoisted_67, [
                    _hoisted_68,
                    _createVNode(_component_Multiselect, {
                      id: "transportationType",
                      class: "mt-1 input-primary",
                      modelValue: _ctx.v$.transportationType.$model,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.v$.transportationType.$model = $event)),
                      placeholder: "Jenis Kendaraan",
                      options: _ctx.transportationTypeOption,
                      searchable: true
                    }, null, 8, ["modelValue", "options"]),
                    (
                        (_ctx.v$.transportationType.$invalid && _ctx.submitted) ||
                          _ctx.v$.transportationType.$pending.$response
                      )
                      ? (_openBlock(), _createBlock("small", _hoisted_69, _toDisplayString(_ctx.v$.transportationType.required.$message), 1))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_70, [
                      (_ctx.tempUploadStnk)
                        ? (_openBlock(), _createBlock("div", _hoisted_71, [
                            (_ctx.tempUploadStnk !== null)
                              ? (_openBlock(), _createBlock("div", {
                                  key: 0,
                                  class: "flex items-center rounded-full bg-red-500 absolute p-1 cursor-pointer",
                                  style: {"right":"0","top":"0","z-index":"5"},
                                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.tempUploadStnk = null))
                                }, [
                                  _hoisted_72
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode("img", {
                              src: _ctx.tempUploadStnk,
                              class: "w-full h-20"
                            }, null, 8, ["src"])
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_73, [
                            (_ctx.uploadStnk.src !== null)
                              ? (_openBlock(), _createBlock("div", {
                                  key: 0,
                                  class: "flex items-center rounded-full bg-red-500 absolute p-1 cursor-pointer",
                                  style: {"right":"0","top":"0","z-index":"5"},
                                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.removeImage('uploadStnk')))
                                }, [
                                  _hoisted_74
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_file_upload, {
                              ref: "refUploadStnk",
                              "input-id": "idUploadStnk",
                              onInputFile: _ctx.onUploadStnk,
                              accept: "image/*"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.uploadStnk?.src === null)
                                  ? (_openBlock(), _createBlock("img", {
                                      key: 0,
                                      class: "w-full h-20",
                                      src: _imports_0,
                                      alt: _ctx.uploadStnk?.name
                                    }, null, 8, ["alt"]))
                                  : (_openBlock(), _createBlock("img", {
                                      key: 1,
                                      class: "w-full object-cover rounded-lg h-32",
                                      src: _ctx.uploadStnk.src,
                                      alt: _ctx.uploadStnk.name
                                    }, null, 8, ["src", "alt"]))
                              ]),
                              _: 1
                            }, 8, ["onInputFile"])
                          ]))
                    ])
                  ]),
                  _createVNode("div", _hoisted_75, [
                    _hoisted_76,
                    _createVNode(_component_Multiselect, {
                      id: "statusVaksin",
                      class: "mt-1 input-primary",
                      modelValue: _ctx.v$.statusVaksin.$model,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.v$.statusVaksin.$model = $event)),
                      placeholder: "Covid-19 Vaksin",
                      options: _ctx.statusVaksinOption,
                      searchable: true,
                      mode: "tags"
                    }, null, 8, ["modelValue", "options"]),
                    (
                        (_ctx.v$.statusVaksin.$invalid && _ctx.submitted) ||
                          _ctx.v$.statusVaksin.$pending.$response
                      )
                      ? (_openBlock(), _createBlock("small", _hoisted_77, _toDisplayString(_ctx.v$.statusVaksin.required.$message), 1))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_78, [
                      (_ctx.tempUploadSertifikat)
                        ? (_openBlock(), _createBlock("div", _hoisted_79, [
                            (_ctx.tempUploadSertifikat !== null)
                              ? (_openBlock(), _createBlock("div", {
                                  key: 0,
                                  class: "flex items-center rounded-full bg-red-500 absolute p-1 cursor-pointer",
                                  style: {"right":"0","top":"0","z-index":"5"},
                                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.tempUploadSertifikat = null))
                                }, [
                                  _hoisted_80
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode("img", {
                              src: _ctx.tempUploadSertifikat,
                              class: "w-full h-20"
                            }, null, 8, ["src"])
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_81, [
                            (_ctx.uploadSertifikat.src !== null)
                              ? (_openBlock(), _createBlock("div", {
                                  key: 0,
                                  class: "flex items-center rounded-full bg-red-500 absolute p-1 cursor-pointer",
                                  style: {"right":"0","top":"0","z-index":"5"},
                                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.removeImage('uploadSertifikat')))
                                }, [
                                  _hoisted_82
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_file_upload, {
                              ref: "refUploadSertifikat",
                              "input-id": "idUploadSertifikat",
                              onInputFile: _ctx.onUploadSertifikat,
                              accept: "image/*"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.uploadSertifikat?.src === null)
                                  ? (_openBlock(), _createBlock("img", {
                                      key: 0,
                                      class: "w-full h-20",
                                      src: _imports_0,
                                      alt: _ctx.uploadSertifikat?.name
                                    }, null, 8, ["alt"]))
                                  : (_openBlock(), _createBlock("img", {
                                      key: 1,
                                      class: "w-full object-cover rounded-lg h-32",
                                      src: _ctx.uploadSertifikat.src,
                                      alt: _ctx.uploadSertifikat.name
                                    }, null, 8, ["src", "alt"]))
                              ]),
                              _: 1
                            }, 8, ["onInputFile"])
                          ]))
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_83, [
            _hoisted_84,
            _createVNode(_component_InputSwitch, {
              modelValue: _ctx.dataForm.isActive,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.dataForm.isActive = $event)),
              class: "switch-og mt-1"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode("div", _hoisted_85, [
            (_ctx.route.meta.permission.update)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  label: "Simpan",
                  class: "font-semibold p-button-sm btn-primary px-10",
                  type: "submit"
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_Button, {
              class: "btn-secondary text-black px-10 py-1",
              onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.redirectBack()))
            }, {
              default: _withCtx(() => [
                _hoisted_86
              ]),
              _: 1
            }),
            (_ctx.Id && _ctx.route.meta.permission.delete)
              ? (_openBlock(), _createBlock("div", {
                  key: 1,
                  class: "background-red-lighten-5 p-3 rounded-md cursor-pointer",
                  onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.deleteData()))
                }, [
                  _hoisted_87
                ]))
              : _createCommentVNode("", true),
            (!_ctx.dataForm.isBlocked && _ctx.route.meta.permission.update && _ctx.Id)
              ? (_openBlock(), _createBlock("div", {
                  key: 2,
                  class: "background-red px-3 py-2 rounded-md cursor-pointer",
                  onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.blockedCourier()))
                }, [
                  _hoisted_88
                ]))
              : _createCommentVNode("", true),
            (_ctx.dataForm.isBlocked && _ctx.route.meta.permission.update && _ctx.Id)
              ? (_openBlock(), _createBlock("div", {
                  key: 3,
                  class: "background-green px-3 py-2 rounded-md cursor-pointer",
                  onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.blockedCourier()))
                }, [
                  _hoisted_89
                ]))
              : _createCommentVNode("", true)
          ])
        ], 32)
      ]),
      _: 1
    }),
    _createVNode(_component_GoogleAutocomplete, {
      onSendDetail: _ctx.setResultAddress,
      event: _ctx.addressRef,
      search: _ctx.dataForm.address
    }, null, 8, ["onSendDetail", "event", "search"])
  ]))
}